import { ApolloClient, from } from '@apollo/client';

import { getConfiguredCache } from 'state/graphql/cache';
import { commitOrderTestErrorModalLink } from 'state/graphql/links/commit-order-test-error-modal-link';
import { httpLink } from 'state/graphql/links/http-link';
import {
  conditionallyRemoveTypenameFromQueryLink,
  stripTypenameFromVarsLink,
} from 'state/graphql/links/strip-typename';
import { withErrorLogger } from 'state/graphql/links/with-error-logger';
import { withHeaders } from 'state/graphql/links/with-headers';

import { headers } from './headers';
import { withLDFlagsHeader } from './links/with-ld-flags-header';

/**
 * Apollo Client instance
 *
 * Client should only be instantiated once per app
 * @see https://github.com/apollographql/apollo-client-devtools/issues/822
 */
export const apolloClient = new ApolloClient({
  cache: getConfiguredCache(),
  link: from([
    withLDFlagsHeader,
    commitOrderTestErrorModalLink,
    withHeaders(headers),
    withErrorLogger,
    stripTypenameFromVarsLink,
    conditionallyRemoveTypenameFromQueryLink,
    httpLink,
  ]),
  headers,
});
